export default __webpack_public_path__ + "images/8fb29cbffeaad1851b381a6b47c4d277-retreat.jpg";